import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Footer from '../components/Footer';
import GlobalStyle from '../styles/GlobalStyle';
import { ModalProvider } from '../context/ModalContext';
import OwnerRezForm from '../components/reusable/forms/IntegrationWaitListForms/OwnerRez';
import PmsForm from '../components/reusable/forms/PMSForm/PmsForm';
import ContactUsPopUp from '../components/reusable/forms/contact/ContactUsPopUp';
import Navbar from '../components/NavbarV3';

const GlobalWrapper = styled.section`
    height: 100%;
    width: 100%;
    overflow: hidden;
`;

const RootLayout = (props) => {
    return (
        <GlobalWrapper>
            <GlobalStyle />
            <ModalProvider>
                <Navbar
                    isHomePage={props.isHomePage}
                    getStartedCtaLink={props?.getStartedCtaLink}
                />

                {props.children}
                <ContactUsPopUp />
                <PmsForm />
                <OwnerRezForm />
            </ModalProvider>
            <Footer />
        </GlobalWrapper>
    );
};

RootLayout.propTypes = {
    isHomePage: PropTypes.bool,
    children: PropTypes.node,
    getStartedCtaLink: PropTypes.string,
};

export default RootLayout;
